import script from "./certificateBaseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./certificateBaseInfo.vue?vue&type=script&setup=true&lang=js"

import "./certificateBaseInfo.vue?vue&type=style&index=0&id=bbe34c08&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbe34c08"]])

export default __exports__